import { Layout } from 'antd';
import DashboardHeader from './DashboardHeader';
import React from 'react';

const { Content } = Layout;

const DashboardLayout = React.memo(({ children }) => {
    return (
        <Layout style={{ minHeight: '100vh' }}>
            <DashboardHeader />
            <Content style={{
                padding: '24px',
                background: '#f5f5f5'
            }}>
                <div style={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                    background: '#fff',
                    padding: '24px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                }}>
                    {children}
                </div>
            </Content>
        </Layout>
    );
});

export default DashboardLayout;